import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import whiteLogo from "../../img/main/white_logo.png";

const IntroOverlay: React.FC<{ onFinish?: () => void }> = ({ onFinish }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer1 = setTimeout(() => setFadeOut(true), 3000); // 2초 후 페이드아웃 시작
    const timer2 = setTimeout(() => {
      setVisible(false);
      if (onFinish) onFinish();
    }, 5000); // 3초 후 오버레이 제거
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [onFinish]);

  if (!visible) return null;

  return (
    <Overlay $fadeOut={fadeOut}>
      <Logo src={whiteLogo} alt="logo" />
    </Overlay>
  );
};

export default IntroOverlay; 

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;
const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const Overlay = styled.div<{ $fadeOut: boolean }>`
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  animation: ${({ $fadeOut }) => ($fadeOut ? fadeOut : "none")} 2s forwards;
`;

const Logo = styled.img`
  width: 100px;
  height: auto;
  opacity: 0;
  animation: ${fadeIn} 1s 1s forwards, ${fadeOut} 3.5s 3.5s forwards;
  @media (max-width: 768px) {
    width: 80px;
  }
`;